import React from "react";

export const AuditReportIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({
    className = "w-6 h-6 text-gray-100",
    ...props
}) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" className={className} {...props}>
            <rect x="7" y="6" width="10" height="12" rx="2" stroke="currentColor" stroke-width="1.5" fill="none" />
            <path d="M13 6 Q17 6 17 10 L13 10 Z" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" fill="none" />
            <line x1="9" y1="13" x2="13" y2="13" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
            <line x1="9" y1="15" x2="14" y2="15" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};